import { useEffect, useMemo, useState, useRef } from "react";
import redirectURL from "../redirectURL.js"
import { AgGridReact } from "ag-grid-react";
import SweetAlert from "react-bootstrap-sweetalert";
import { Modal, Button, Tooltip, OverlayTrigger } from "react-bootstrap";

export default function ContactMaster() {
    const [rowData, setRowData] = useState([])
    const [showSlider, setShowSlider] = useState("")
    const [dealerdetails, setDealerDetails] = useState({
        consignee_code: "",
        consignee_name: "",
        mobile_no: "",
        email_id: "",
    })
    const [show, setShow] = useState(false)
    const [basicType, setBasicType] = useState("")
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [basicTitle, setBasicTitle] = useState("")
    const [sliderText, setSliderText] = useState("")
    const [isEdit, setEdit] = useState(false)
    const [errMsg, setErrMsg] = useState("")
    const [emailMsg, setemailMsg] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [isNoHovered, setNoHovered] = useState(false)
    const [isEmailHovered, setEmailHovered] = useState(false)
    const [overlay, setOverlay] = useState("show-n")
    const [showLoader, setShowLoader] = useState("show-n")


    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: true,
        wrapText: true
    };

    const colDefs = useMemo(() => {
        return [
            {
                headerName: "",
                field: "_id",
                width: 40,
                filter: false,
                cellRenderer: (param) => {
                    if (param.data?.mobile_no != undefined) {
                        return (<div> <i title="Edit" onClick={(e) => onclickEditButton(e, param)} className="fa fa-edit"></i></div>)
                    }
                    else {
                        return (<div> <i title="Edit" onClick={(e) => onclickEditButton(e, undefined)} className="fa fa-edit"></i></div>)
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },

            {
                headerName: "",
                field: "_id",
                width: 40,
                filter: false,
                cellRenderer: (param) => {
                    return (<div> <i title="Delete" onClick={(e) => onclickDeleteButton(e, param)} className="fa fa-trash"></i></div>)
                }
                ,
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Dealer Code",
                field: "consignee_code",
                width: 150,
            },

            {
                headerName: "Dealer Name",
                field: "consignee_name",
                width: 150,
                valueGetter: (params) => {
                    const name = params.data?.consignee_name;
                    if (!name) return "";
                    if (Array.isArray(name) && name.length > 0) return name.join(", ");
                    if (typeof name === 'string') {
                        try {
                            const parsed = JSON.parse(name);
                            if (Array.isArray(parsed)) return parsed.join(", ");
                            return name;
                        } catch (err) {
                            return name;
                        }
                    }
                    return "";
                }
            },

            {
                headerName: "Dealer Mobile No",
                field: "mobile_no",
                width: 160,
                valueGetter: (params) => {
                    const mobileNo = params.data?.mobile_no;
                    if (!mobileNo) return "";
                    if (Array.isArray(mobileNo) && mobileNo.length > 0) {
                        return mobileNo.join(", ");
                    } else if (typeof mobileNo === "string" && mobileNo.trim() !== "") {

                        return mobileNo;
                    } else {
                        return "";
                    }
                }
            },
            {
                headerName: "Dealer Email",
                field: "email_id",
                width: 160,
                valueGetter: (params) => {
                    const mail = params.data?.email_id;
                    if (!mail) return "";
                    if (Array.isArray(mail) && mail.length > 0) {
                        return mail.join(", ");
                    } else if (typeof mail === "string" && mail.trim() !== "") {
                        return mail;
                    } else {
                        return "";
                    }

                }
            },

        ]
    })

    const fetchConsigneeDetails = () => {
        let query = { operation: "fetch" }
        setShowLoader("show-m")
        redirectURL.post("/consigneecontactlist", query)
            .then((res) => {
                if (res.status == 200) {
                    setShowLoader("show-n")
                    let data = res.data.output || [];
                    data.sort((a, b) => {
                        if (!a._id) return 1;
                        if (!b._id) return -1;
                        return a._id < b._id ? 1 : (a._id > b._id ? -1 : 0);
                    });

                    setRowData(data);
                }
            })
            .catch(err => console.error(err));
    }
    const onclickDeleteButton = async (e, param) => {
        setDealerDetails({ "consignee_code": param.data.consignee_code })
        setShowDeleteAlert(true);
    }

    useEffect(() => {
        fetchConsigneeDetails()
    }, [])

    const onInputChange = (e) => {
        const { name, value } = e.target

        setDealerDetails((prevData) => ({
            ...prevData,
            [name]: value
        }))

    }

    const onMobileNoChange = (e, index) => {
        let no_details = dealerdetails.mobile_no
        let nos = e.target.value.split(",").map(num => num.trim());
        const filteredNos = nos.filter(n => n !== "");
        const allTenDigits = filteredNos.length > 0 && filteredNos.every(n => n.length === 10);

        if (allTenDigits) {
            setErrMsg("");
        }

        setDealerDetails((prevData) => ({
            ...prevData,
            mobile_no: nos
        }))
    }

    const handleMouseEnter = (e, type) => {
        if (type == "dealer_no") {
            setNoHovered(true)
        }
        else {
            setEmailHovered(true)
        }
    }

    const handleMouseOut = (e, type) => {
        if (type == "dealer_no") {
            setNoHovered(false)
        }
        else {
            setEmailHovered(false)
        }
    }

    const onEmailChange = (e, index) => {
        const { value } = e.target;
        const current = dealerdetails.email_id;

        if (typeof index === 'number') {
            const arr = Array.isArray(current)
                ? [...current]
                : (current ? String(current).split(',').map(s => s.trim()) : []);
            arr[index] = value;
            setDealerDetails((prevData) => ({
                ...prevData,
                email_id: arr
            }));
            setemailMsg("");
            return;
        }

        setDealerDetails((prevData) => ({
            ...prevData,
            email_id: value
        }));
        setemailMsg("");
    }
    const onclickEditButton = (e, param) => {
        setSliderText("Edit Dealer")
        setShowSlider("slider-translate")
        setEdit(true)
        setOverlay("show-m")

        if (param != undefined) {
            const dealer = param.data;
            const dealerName = Array.isArray(dealer.consignee_name)
                ? dealer.consignee_name.join(", ")
                : (typeof dealer.consignee_name === "string" ? dealer.consignee_name : "");

            const mobile = Array.isArray(dealer.mobile_no) ? dealer.mobile_no : (dealer.mobile_no || "");
            const email = Array.isArray(dealer.email_id) ? dealer.email_id.join(", ") : (dealer.email_id || "");

            setDealerDetails({
                _id: dealer._id,
                consignee_code: dealer.consignee_code,
                consignee_name: dealerName || "",
                mobile_no: mobile || "",
                email_id: email || ""
            });
        }
    }


    const onClickCloseBtn = () => {
        setOverlay("show-n")
        setShowSlider("")
        setDealerDetails({
            consignee_code: "",
            consignee_name: "",
            mobile_no: "",
            email_id: "",
        })
        setEdit(false)
    }

    const onFormSubmit = async (e) => {
        e.preventDefault()
        setOverlay("show-m")
        let formData = { ...dealerdetails }
        if (isEdit) {
            formData["operation"] = "update"
        }
        else { formData["operation"] = "" }

        let mobile = formData.mobile_no
        let email = formData.email_id
        let dealerName = formData.consignee_name



        if (Array.isArray(mobile)) {
            mobile = mobile.map(m => (typeof m === 'string' ? m.trim() : m)).filter(m => m !== "");
        } else if (typeof mobile === 'string') {
            if (mobile.includes(",")) {
                mobile = mobile.split(",").map(num => num.trim()).filter(n => n !== "");
            } else {
                mobile = mobile.trim();
            }
        }

        if (Array.isArray(email)) {
            email = email.map(em => (typeof em === 'string' ? em.trim() : em)).filter(em => em !== "");
        } else if (typeof email === 'string') {
            if (email.includes(",")) {
                email = email.split(",").map(mail => mail.trim()).filter(m => m !== "");
            } else {
                email = email.trim();
            }
        }
        if (typeof dealerName === 'string') {
            if (dealerName.includes(",")) {
                dealerName = dealerName.split(",").map(n => n.trim()).filter(n => n !== "");
            } else {
                dealerName = dealerName.trim();
            }
        }
        formData["consignee_name"] = dealerName;
        const regex = /^[6-9][0-9]{0,9}$/;
        if (Array.isArray(mobile)) {
            if (mobile.length > 3) {
                setErrMsg("Please provide valid number");
                return;
            }
            for (let each of mobile) {
                if (each.length < 10 || !regex.test(each)) {
                    setErrMsg("Please provide valid number");
                    return;
                }
            }
            formData["mobile_no"] = mobile
        }
        else {
            if (typeof mobile !== 'string' || mobile.length < 10 || !regex.test(mobile)) {
                setErrMsg("Only 3 mobile nos can added at once");
                return;
            }



        }

        if (Array.isArray(email)) {
            if (email.length > 3) {
                setErrMsg("Only 3 mail ids can be added at once.");
                return;
            }
            for (let each of email) {
                if (!(each.includes("@") & (each.includes(".in") | each.includes(".com")))) {
                    setemailMsg("Please provide valid email");
                    return;
                }


            }
            formData["email_id"] = email
        }
        else {
            if (!(formData.email_id.includes("@") & (formData.email_id.includes(".in") | formData.email_id.includes(".com")))) {
                setemailMsg("Please provide valid email");
                return;
            }
            formData["email_id"] = [email]
        }
        const res = await redirectURL.post("/consigneecontactlist", formData)
        if (res && res.status >= 200 && res.status < 300) {
            setShow(true)
            setBasicTitle("Uploaded successfully")
            setBasicType("success")
            setShowSlider("")
            setSliderText("")
            fetchConsigneeDetails()
            setDealerDetails({ consignee_code: "", consignee_name: "", mobile_no: "", email_id: "" })
        }
    }

    const closeAlert = () => {
        setShow(false)
        setBasicTitle("")
        setBasicType("")
        setShowSlider("")
        setShowModal(false)
        setOverlay("show-n")
    }

    const handleAddDealer = (e) => {
        setShowSlider("slider-translate")
        setSliderText("Add Dealer")
        setOverlay("show-m")

    }

    const handleClose = () => {
        setOverlay("show-n")
        setShowModal(false)
        setShowSlider("")
    }

    const confirmDelete = async () => {
        let formdata = { consignee_code: dealerdetails.consignee_code }
        setShowLoader("show-m")
        const res = await redirectURL.post("/deleteConsigneeContactDetails", formdata)
        if (res && res.status >= 200 && res.status < 300) {
            setShowLoader("show-n")
            setShowDeleteAlert(false);
            setShow(true)
            setBasicTitle("Dealer Details Deleted Successfully.")
            setBasicType("success")
            fetchConsigneeDetails();
            setShowModal(false)
            setShow(true)
            setBasicTitle("Dealer Details Deleted Successfully.")
            setBasicType("success")
        }
    }



    return (
        <div className="container-fluid">
            <div>
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={closeAlert}
                    style={{ fontSize: "9px" }}
                >
                </SweetAlert>
                <SweetAlert
                    show={showDeleteAlert}
                    type="danger"
                    warning={false}
                    danger
                    showCancel
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Delete"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    title="Confirm Delete"
                    onConfirm={confirmDelete}
                    onCancel={() => setShowDeleteAlert(false)}
                >
                    Are you sure you want to delete this record?
                </SweetAlert>
                <div className="row d-flex justify-content-between">
                    <h5 className="ml-3">Dealer Contact Master</h5>
                    <button className="btn btn-warning" style={{ float: "left", border: "none", marginBottom: "5px", marginRight: "15px" }} onClick={handleAddDealer}><i className="icon-plus"></i>&nbsp; Add Dealer </button>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className={"ag-theme-balham mt-8"} style={{ height: '600px', width: '100%', paddingTop: "1rem" }}>
                            <AgGridReact defaultColDef={defaultColDef} columnDefs={colDefs} rowData={rowData} pagination={true} paginationAutoPageSize={50} />

                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (showSlider)}>
                    <div className="slide-r-title"><h4>
                        {sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "12px" }} onClick={onClickCloseBtn}>X</span></h4></div >
                    <div style={{ position: "relative" }} className="slide-r-body">
                        <form onSubmit={onFormSubmit}>
                            <div className="form-group d-flex flex-column mr-4">
                                <label>Dealer Code <span style={{ color: "#ff5370" }}>* </span></label>
                                {isEdit ?<input disabled type="text" value={dealerdetails.consignee_code} name="consignee_code" className="form-control" /> :<input type="text" value={dealerdetails.consignee_code} onChange={onInputChange} name="consignee_code" className="form-control" required />}
                            </div>

                            <div className="form-group mr-4">
                                <label>
                                    Dealer Name <span style={{ color: "#ff5370" }}>* </span>
                                </label>
                               { isEdit ? 
                               <input
                                    type="text"
                                    value={dealerdetails.consignee_name}
                                    name="consignee_name"
                                    className="form-control mr-2"
                                    disabled
                                /> :
                               <input
                                    type="text"
                                    value={dealerdetails.consignee_name}
                                    onChange={onInputChange}
                                    name="consignee_name"
                                    className="form-control mr-2"
                                    required
                                />}
                            </div>


                            {isEdit ? <div className="form-group mr-4">
                                <label>
                                    Dealer Number<span style={{ color: "#ff5370" }}> *</span>
                                </label>
                                <input
                                    type="text"
                                    value={dealerdetails.mobile_no}
                                    onChange={(e) => onMobileNoChange(e)}
                                    name="mobile_no"
                                    className="form-control mr-2"
                                    required
                                />
                            </div> : <div className="form-group mr-4">

                                <label style={{ display: "block" }}>
                                    Dealer Number<span style={{ color: "#ff5370" }}> *  </span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="tooltip-example">A maximum of 3 comma-separated numbers can be entered</Tooltip>}>
                                        <i className="fa fa-info-circle" style={{ fontSize: "10px" }}></i>
                                    </OverlayTrigger>
                                </label>
                                <input
                                    type="text"
                                    value={dealerdetails.mobile_no}
                                    onChange={(e) => onInputChange(e)}
                                    name="mobile_no"
                                    className="form-control mr-2"
                                    required
                                />
                            </div>}
                            {<span style={{ fontSize: "11px", color: "#ff0000", marginTop: "5px", display: "block" }}>
                                {errMsg}
                            </span>}
                            {isEdit ?

                                <div className="form-group mr-4">
                                    <label>
                                        Dealer Email<span style={{ color: "#ff5370" }}> *</span>
                                    </label>

                                    <input
                                        type="text"
                                        value={dealerdetails.email_id}
                                        onChange={(e) => onEmailChange(e)}
                                        name="email_id"
                                        className="form-control mr-2"
                                        required
                                    />
                                </div> :
                                (

                                    <div className="form-group mr-4">
                                        <label>
                                            Dealer Email<span style={{ color: "#ff5370" }}> *</span>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip-example">A maximum of 3 comma-separated emails can be entered</Tooltip>}>
                                                <i className="fa fa-info-circle" style={{ fontSize: "10px" }}></i>
                                            </OverlayTrigger>
                                        </label>
                                        <input
                                            type="text"
                                            value={dealerdetails.email_id || ""}
                                            onChange={onInputChange}
                                            name="email_id"
                                            className="form-control mr-2"
                                            required
                                        />
                                    </div>)
                            }
                            {<span style={{ fontSize: "11px", color: "#ff0000", marginTop: "5px", display: "block" }}>
                                {emailMsg}
                            </span>}
                            <button type="submit" className="btn btn-success">Submit</button>
                        </form>

                    </div>

                </div>

                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header className="d-flex justify-content-between align-items-center">
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to delete this record?</Modal.Body>
                    <Modal.Footer>
                        <button className="btn" onClick={handleClose}>Cancel</button>
                        <button className="btn" onClick={confirmDelete}>Delete</button>
                    </Modal.Footer>
                </Modal>
            </div>
            <div className={"overlay-part " + overlay} onClick={handleClose}></div>
            <div className={"dataLoadpage " + (showLoader)}>
            </div>
            <div className={"dataLoadpageimg " + (showLoader)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>

        </div>
    )
}
